import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import { BaseDialog as _BaseDialog } from './base';
import { createVNode, callAll } from 'intact-vue';
import { addStaticMethods } from './staticMethods';
import { usePosition } from './usePosition';
export var BaseDialog = /*#__PURE__*/function (_BaseDialog2) {
  _inheritsLoose(BaseDialog, _BaseDialog2);
  function BaseDialog(props, $vNode, $SVG, $mountedQueue, $senior) {
    var _this;
    if (props === void 0) {
      props = null;
    }
    if ($vNode === void 0) {
      $vNode = createVNode(BaseDialog);
    }
    if ($SVG === void 0) {
      $SVG = false;
    }
    if ($mountedQueue === void 0) {
      $mountedQueue = [];
    }
    if ($senior === void 0) {
      $senior = null;
    }
    _this = _BaseDialog2.call(this, props, $vNode, $SVG, $mountedQueue, $senior) || this;
    _this.useAsComponent = false;
    return _this;
  }
  var _proto = BaseDialog.prototype;
  _proto.init = function init() {
    _BaseDialog2.prototype.init.call(this);
    // @ts-ignore
    if (this.$vNode.tag !== BaseDialog) {
      this.useAsComponent = true;
    }
    usePosition(this.dialogRef);
  };
  _proto.show = function show() {
    var _this2 = this;
    return new _Promise(function (resolve) {
      if (_this2.get('value')) return resolve();
      var show = function show() {
        _this2.set('value', true);
        resolve();
      };
      if (_this2.useAsComponent) {
        return show();
      }
      // use as intance
      var mountedQueue = _this2.$mountedQueue;
      _this2.$init(null);
      var vNode = _this2.$vNode;
      vNode.children = _this2;
      _this2.$render(null, vNode, document.body, null, mountedQueue);
      callAll(mountedQueue);
      if (_this2.$inited) {
        show();
      } else {
        _this2.on('$inited', show);
      }
    });
  };
  return BaseDialog;
}(_BaseDialog);
// for React/Vue type inference
export var Dialog = /*#__PURE__*/function (_BaseDialog3) {
  _inheritsLoose(Dialog, _BaseDialog3);
  function Dialog() {
    return _BaseDialog3.apply(this, arguments) || this;
  }
  return Dialog;
}(BaseDialog);
Dialog.success = void 0;
Dialog.warning = void 0;
Dialog.error = void 0;
Dialog.confirm = void 0;
addStaticMethods(Dialog);